import React from "react";
import CircularLoader from "../Loader/CircularLoader";
import { ButtonProps } from "./types";

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      type = "button",
      onClick,
      onKeyDown,
      innerText,
      Icon,
      iconClass = "",
      SecondaryIcon,
      secondaryIconClass = "",
      innerTextClass = "",
      buttonContainerClass = "",
      secondaryButtonContainerClass = "",
      isLoading = false,
      disabled = false,
      loaderColor = "",
      loaderSize = 13,
      iconLeft = false,
      ariaLabel,
      role,
      ...rest
    },
    ref
  ) => {
    return (
      <button
        ref={ref}
        type={type}
        disabled={disabled || isLoading}
        className={`flex items-center gap-[5px] justify-center focus:outline-none transition duration-150 ease-in-out ${
          buttonContainerClass || "w-full h-fit px-4 py-2"
        }`}
        onClick={onClick}
        onKeyDown={onKeyDown}
        aria-label={ariaLabel}
        aria-busy={isLoading}
        aria-disabled={disabled}
        role={role}
        {...rest}
      >
        <div
          className={`flex items-center gap-[5px] ${secondaryButtonContainerClass}`}
        >
          {Icon && (
            <Icon
              className={`shrink-0 ${
                iconLeft ? "order-1" : "order-2"
              } ${iconClass}`}
            />
          )}
          {innerText && (
            <span
              className={`${
                iconLeft ? "order-2" : "order-1"
              } ${innerTextClass}`}
            >
              {innerText}
            </span>
          )}
        </div>
        {SecondaryIcon && (
          <SecondaryIcon className={`shrink-0 ${secondaryIconClass} order-3`} />
        )}
        {isLoading && (
          <div className="order-last">
            <CircularLoader
              className={`${loaderColor} text-verba-blue dark:text-pure-white`}
              size={loaderSize}
            />
          </div>
        )}
      </button>
    );
  }
);

Button.displayName = "Button";

export default Button;
